const MainNavInit = () => {
  const toggle = document.querySelector('#main-nav');

  if (toggle) {
    const wrappers = Array.from(document.querySelectorAll('.nav-list__wrapper') || []);
    const toggleLabel = document.querySelector('[for="main-nav"]');
    const mainNav = document.querySelector('.header__nav-list.nav-list');

    document.addEventListener('click', (evt) => {
      if (evt.target.id !== 'main-nav') toggle.checked = false;
      resetMenu();
    });
    mainNav.addEventListener('click', (evt) => evt.stopPropagation());
    toggleLabel.addEventListener('click', (evt) => {
      evt.stopPropagation();
      resetMenu();
    });

    const resetMenu = () => {
      wrappers.forEach((element) => {
        const input = element.querySelector('input[type="checkbox"]');
        const body = element.querySelector('.nav-list__wrapper-body');
        const btn = element.querySelector('svg');
        if (input) input.checked = false;
        if (body) body.style.display = 'none';
        if (btn) btn.style.rotate = '180deg';
      });
    };

    // new menu
    wrappers.forEach((element) => {
      const headerElement = element.querySelector('.nav-list__wrapper-header');
      const body = element.querySelector('.nav-list__wrapper-body');
      const btn = headerElement.querySelector('svg');
      headerElement.addEventListener('click', () => {
        const toggle = headerElement.querySelector('input[type="checkbox"]');
        body.style.display = toggle.checked ? 'flex' : 'none';
        btn.style.rotate = toggle.checked ? '0deg' : '180deg';
      });
    });
  }
};

export default MainNavInit;
